import { HoldRepeatController } from "../helpers/hold_repeat"

export default class extends HoldRepeatController {
  static targets = ["display", "hidden"]
  static values = { step: { type: Number, default: 15 } }

  connect() {
    super.connect()
    this._boundSyncDisplay = this._syncDisplay.bind(this)
    this.hiddenTarget.addEventListener("change", this._boundSyncDisplay)
  }

  disconnect() {
    super.disconnect()
    this.hiddenTarget.removeEventListener("change", this._boundSyncDisplay)
  }

  get currentMinutes() {
    return this._parseTime(this.hiddenTarget.value)
  }

  set currentMinutes(value) {
    const clamped = Math.max(0, Math.min(1439, value))
    const hours = Math.floor(clamped / 60)
    const mins = clamped % 60
    const timeStr = String(hours).padStart(2, "0") + ":" + String(mins).padStart(2, "0")
    this.hiddenTarget.value = timeStr
    this.displayTarget.textContent = timeStr
    this.hiddenTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  // false once the value is clamped, so a held button stops repeating at the limit.
  step(direction) {
    const before = this.currentMinutes
    const next = Math.max(0, Math.min(1439, before + direction * this.stepValue))
    if (next === before) return false

    this.currentMinutes = next
    return true
  }

  _parseTime(str) {
    if (!str || !str.includes(":")) return 0
    const [h, m] = str.split(":").map(Number)
    return (h || 0) * 60 + (m || 0)
  }

  _syncDisplay() {
    const timeStr = this.hiddenTarget.value
    if (timeStr && timeStr.includes(":")) {
      this.displayTarget.textContent = timeStr
    }
  }
}
